import { render } from "./SimplifiedNotification.vue?vue&type=template&id=46cff31e&scoped=true"
import script from "./SimplifiedNotification.vue?vue&type=script&lang=js"
export * from "./SimplifiedNotification.vue?vue&type=script&lang=js"

import "./SimplifiedNotification.vue?vue&type=style&index=0&id=46cff31e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46cff31e"]])

export default __exports__